<div class="flex w-full items-end gap-2 md:gap-4">
    <div class="flex-1">
        <mat-form-field
            class="ca-form-field ca-form-field-m with-label ca-form-field-w-full"
            floatLabel="always"
            [hideRequiredMarker]="true"
            subscriptSizing="dynamic"
            appearance="outline"
        >
            <mat-label for="productNamesControl">{{ 'PRODUCT_PICKER.FILTER.DEVICE_NAMES.LABEL' | translate }}</mat-label>
            <input
                [formControl]="productNameControl"
                [placeholder]="'PRODUCT_PICKER.FILTER.DEVICE_NAMES.PLACEHOLDER' | translate"
                data-testid="productNamesControl"
                type="text"
                matInput
            />
        </mat-form-field>
    </div>
    <div class="flex-1">
        <mat-form-field
            appearance="outline"
            class="ca-form-field ca-form-field-m with-label ca-form-field-w-full"
            subscriptSizing="dynamic"
            floatLabel="always"
            [hideRequiredMarker]="true"
        >
            <mat-label for="productTypeControl">{{ 'PRODUCT_PICKER.FILTER.DEVICE_TYPE.LABEL' | translate }}</mat-label>
            <mat-select
                [formControl]="productTypeControl"
                [disableOptionCentering]="true"
                [placeholder]="'PRODUCT_PICKER.FILTER.DEVICE_TYPE.PLACEHOLDER' | translate"
                data-testid="productTypeControl"
                panelClass="ca-dropdown-panel-class"
            >
                @for(productType of productTypeOptions; track productType.value) {
                <mat-option
                    [value]="productType.value"
                    [attr.data-testid]="'productType' + productType.value"
                    [id]="'productType' + productType.value"
                    >{{ productType.label | translate }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <button mat-stroked-button class="max-sm:hidden ca-button ca-button-m shrink-0 whitespace-nowrap" (click)="applyFilters()">
        <span> {{ 'CA.BUTTON.APPLY' | translate }} </span>
    </button>
    <button mat-icon-button class="sm:hidden ca-button shrink-0 whitespace-nowrap" (click)="applyFilters()">
        <ca-icon icon="magnifier" class="ca-icon-s-19-p-0-f-19"></ca-icon>
    </button>
</div>
